import * as React from "react";

import { StatusPill } from "@/components/ui/status-pill";

const priorityMap = {
  urgent: { tone: "danger", label: "Urgent" },
  high: { tone: "warning", label: "High" },
  medium: { tone: "info", label: "Medium" },
  low: { tone: "neutral", label: "Low" },
};

const PriorityBadge = React.forwardRef(
  ({ priority = "low", label, className, ...props }, ref) => {
    const key = String(priority).toLowerCase();
    const config = priorityMap[key] || priorityMap.low;
    return (
      <StatusPill
        ref={ref}
        tone={config.tone}
        label={label ?? config.label}
        className={className}
        {...props}
      />
    );
  }
);
PriorityBadge.displayName = "PriorityBadge";

export { PriorityBadge };
